module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/icon_prev-03b643baed7cfdb421a084944ff43db2.svg";